import { useEffect } from 'react';

import { useStores } from '~store';
import { Nullable } from '~types/Nullable';

export default function useMessagingOpenConversation(channelId: Nullable<string>) {
  const { messagingOpenConversationStore } = useStores();

  useEffect(() => {
    if (!channelId) return;

    return messagingOpenConversationStore.open(channelId);
  }, [channelId]);
}
